// require('../../Modules/Shop/Resources/assets/js/bootstrap');

// Vue.component('example-component', require('./components/ExampleComponent.vue').default);
require('./bootstrap');

Vue.mixin({
    methods: {
        nl2br(str, replaceMode, isXhtml) {
            var breakTag = (isXhtml) ? '<br />' : '<br>';
            var replaceStr = (replaceMode) ? '$1' + breakTag : '$1' + breakTag + '$2';
            return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, replaceStr);
        }
    }
})

const app = new Vue({
    el: '#app',
});

document.addEventListener('DOMContentLoaded', function () {
    var videoBlockClicked = false;
    var videoBlocks = this.querySelectorAll('.video-block')
    videoBlocks.forEach(function (videoBlock) {
        var video = videoBlock.querySelector('video');
        // MOBILE
        if (videoBlock.classList.contains('mobile-video-block')) {
            videoBlock.addEventListener('click', function () {

                if (!document.fullscreenElement) {
                    video.play();
                    if (video.requestFullscreen) {
                        video.requestFullscreen();
                    } else if (video.webkitRequestFullscreen) { // Safari
                        video.webkitRequestFullscreen();
                    } else if (video.msRequestFullscreen) { // IE11
                        video.msRequestFullscreen();
                    } else if (video.mozRequestFullScreen) { // Firefox
                        video.mozRequestFullScreen();
                    }
                }
            });
            document.addEventListener('fullscreenchange', () => {
                if (!document.fullscreenElement) {
                    video.load()
                }
            });
        }
        // DESKTOP
        else {
            videoBlock.addEventListener('click', function () {

                if (videoBlockClicked) return;
                videoBlockClicked = true;

                this.querySelector('.bg-overlay').style.display = 'none';
                video.play();
            });
        }
    });
});
